import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import CategoryPage from "../pages/category/page";
import DetailPage from "../pages/detail/page";
import SearchPage from "../pages/search/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/category/movie",
    element: <CategoryPage type="movie" />,
  },
  {
    path: "/category/tv",
    element: <CategoryPage type="tv" />,
  },
  {
    path: "/detail/movie/:id",
    element: <DetailPage type="movie" />,
  },
  {
    path: "/detail/tv/:id",
    element: <DetailPage type="tv" />,
  },
  {
    path: "/search",
    element: <SearchPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;